import React from 'react';
import { connect } from 'react-redux';
import config from "config"
import { editUser } from "actions/user"
class EditModalContent extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			loaded: false,
			role: config.roles[0].code,
			location: {
				node: {
					id: -2
				}
			},
			disabled: true
		};
	}
	componentDidMount() {
		this.props.onRef(this)
	}
	componentWillUnmount() {
		this.props.onRef(undefined)
	}
	editUser() {
		var info = {
			username: this.props.user.username,
			rootnodeid: this.state.location.node.id,
			companyid: this.state.location.node.id,
			role: this.refs.role.value.substring(1)
		}
		this.props.dispatch(editUser(info));
	}

	findRole(u) {
		// Company admin
		var res = "";
		var allUsers = [
			this.props.contact.companyadmins,
			this.props.contact.localadmins,
			this.props.contact.localusers,
			this.props.contact.supportusers
		]
		allUsers.map((userlist, i) => {
			userlist.map((user) => {
				if (u.username == user.username) {
					res = config.roles[i].code;
				}
			});
		});
		return res;
	}

	componentWillReceiveProps(nextProps) {
		let hasCompany = (nextProps.nodes.length > 0);
		nextProps.nodes.map((x) => {
			if (x.node.type == config.nodeType.customer.code) {
				hasCompany = true;
			}
		});
		this.setState({ hasCompany: hasCompany });
		if (this.props.onOpen !== nextProps.onOpen) {
			let role = this.findRole(nextProps.user);
			this.setState({
				role: this.findRole(nextProps.user),
				location: nextProps.nodes[this.findNode(nextProps.user.rootnodeid)],
				loaded: true,
				disabled: (role == config.roles[0].code)
			});
		}
	}

	findCustomerNode(nodes) {
		var res = {};
		nodes.map((x) => {
			if (x.node.type == config.nodeType.customer.code) {
				res = x;
			}
		});
		return res;
	}

	findNotCustomerNode(nodes) {
		var res = null;
		for (var i = 0; i < nodes.length; i++) {
			if (nodes[i].node.type != config.nodeType.customer.code) {
				return (nodes[i]);
			}
		}
		return res;
	}

	PairOk(roleCode, location) {
		switch (roleCode) {
			case config.roles[0].code: // Company admin
				return location.type == config.nodeType.customer.code;
			case config.roles[1].code: // Local admin
				return location.type != config.nodeType.customer.code;
			default:
				return true;
		}
	}

	changeRole(e) {
		if (e.target.value == config.roles[0].code) {
			this.setState({
				role: e.target.value,
				location: this.findCustomerNode(this.props.nodes),
				disabled: true
			});
		} else {
			let loc = this.state.location;
			if (loc.node.type == config.nodeType.customer.code) {
				loc = this.findNotCustomerNode(this.props.nodes);
			}
			this.setState({
				role: e.target.value,
				location: loc,
				disabled: false
			});
		}
	}

	changeLocation(e) {
		this.setState({ location: this.props.nodes[e.target.value] })
	}

	findNode(id) {
		var idx = 0;
		this.props.nodes.map((x, i) => {
			if (x.node.id == id) {
				idx = i;
			}
		});
		return idx;
	}

	render() {
		return (
			<React.Fragment>
				<label>Change Role</label>
				<select required ref="role" onChange={this.changeRole.bind(this)} value={this.state.role}>
					{config.roles.map((role, i) => {
						if (!this.state.hasCompany && i == 0) {
							return null
						}
						return <option value={role.code} key={role.text}> {role.text} </option>
					})}
				</select>

				<label>Change Location</label>
				<select required ref="location"
					disabled={this.state.disabled}
					value={this.findNode(this.state.location.node.id)}
					onChange={this.changeLocation.bind(this)}
				>
					{this.props.nodes.map((x, i) => {
						if (x.node.type != "location" && x.node.type != "customer") {
							return null;
						}
						return (
							<option value={i} key={"o" + x.node.id} disabled={!this.PairOk(this.state.role, x.node)}>
								{x.padding}
								{x.node.info.name}
							</option>
						);
					})}
				</select>
				<div><span className={this.props.respondClass}>{this.props.respond}</span></div>
			</React.Fragment >
		);
	}
}

function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap
	};
}

function mapDispatchToProps(dispatch) {
	return {
		dispatch
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(EditModalContent);


// WEBPACK FOOTER //
// ./src/components/pages/user/editModalContent.jsx